const $cartData = $('.js-cart-data');
const $deliveryToggle = $('.js-delivery-toggle');
const $delivery = $('#delivery-fieldset');
const $typeToggle = $('.js-type-selector');
const $countrySelect = $('.js-country-select');

const cartData = {
  initialize() {
    if ($cartData.length) {
      this.createEvents();
      this.checkDeliveryOpen();
      this.checkOrderType();
    }

    this.checkCountryHasVatNumber();
    $countrySelect.on('change', () => {
      this.checkCountryHasVatNumber();
    });
  },

  createEvents() {
    $deliveryToggle.on('change', () => {
      this.checkDeliveryOpen();
    });

    $typeToggle.on('change', () => {
      this.checkOrderType();
    });

    $countrySelect.on('change', () => {
      this.checkCountryHasVatNumber();
    });
  },

  checkDeliveryOpen() {
    const isOpen = $deliveryToggle.is(':checked');
    $delivery.toggle(isOpen);

    if (isOpen) {
      $delivery.find('[data-required]')
        .attr('required', true);
    } else {
      $delivery.find('[required]')
        .removeAttr('required');
    }
  },

  checkOrderType() {
    const $checked = $typeToggle.filter(':checked');

    if ($checked.length) {
      const val = $checked.data('value');
      const $typeItems = $('[data-order-type]');

      $typeItems.toArray()
        .forEach((item) => {
          const $item = $(item);
          const type = $item.data('order-type');

          $item.toggle(type === val);
        });
    }
  },

  checkCountryHasVatNumber() {
    const $hasVatNumber = !!$countrySelect.find(':selected').data('has_vat_number');

    $('.js-show-vat-number').toggle($hasVatNumber);
  },
};

export default cartData;
